<template>
    <el-table
        v-loading="status == 'loading'"
        :data="datas"
        style="width: 100%"
        empty-text="沒有資料"
        class="accounting-summary-table accounting-summary-petty-money-table"
        :height="maxHeight"
        border
        @selection-change="$emit('selected', $event)"
        @row-click="onRowClick"
    >
    <el-table-column type="selection" width="42" fixed></el-table-column>
        <el-table-column label="系統單號" width="100" align="left" fixed>
            <template slot-scope="scope">
                <span @click="$event => onClick($event, scope.row)" style="font-size: 8.5pt;">{{ scope.row.systemNo }}</span>
            </template>
        </el-table-column>
        <el-table-column label="財會檢核" align="left" width="80" fixed>
            <template slot-scope="scope">
                <AccountingStatusLabel :statusNum="scope.row.vocherStatus" />
            </template>
        </el-table-column>
        <el-table-column label="核准傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{'blur-zero' : scope.row.approvedVocherQty === 0}">{{ scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column label="待辦傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{ 'blur-zero': scope.row.vocherQty - scope.row.approvedVocherQty === 0 }">{{ scope.row.vocherQty - scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="dat" label="日期" width="100">
            <template slot-scope="scope">
                <div>{{ scope.row.dat | dateFormater("YYYY-MM-dd") }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="typ" label="類型" width="60">
            <template slot-scope="scope">
                <div>{{ scope.row.typ === 1 ? "轉入" : "轉出" }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="bankName" label="銀行帳戶" width="180" />
        <el-table-column prop="amt" label="金額" align="right" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.amt" />
                <span style="color: #aaa; margin-left: 5px;">TWD</span>
            </template>
        </el-table-column>
        <el-table-column prop="mem" label="備註" />
        <el-table-column label="建立日期" width="120">
            <template slot-scope="scope">
                <span>{{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _ from 'lodash';
import AccountingStatusLabel from '@/components/dashboard/Accounting/AccountingSummary/ui/AccountingStatusLabel.vue';
import { PAY_WAY_LIST } from '@/assets/commonData/options';
import AccountingTableMixins from '../AccountingTableMixins.vue';

export default {
    mixins: [AccountingTableMixins],
    props: {
        status: {
            type: String,
            default: '',
        },
        datas: {
            type: Array,
            default: () => [],
        },
    },
    components: { AccountingStatusLabel },
    methods: {
        onClick(e, data) {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('openReceipt', data);
        },
        onRowClick(data) {
            this.$emit('openDetail', data.sno, data.vocherStatus);
        },
        getPayWayText(val) {
            return _.find(PAY_WAY_LIST, ['value', val])?.label || '--';
        },
    },
};
</script>

<style lang="scss">
.accounting-summary-petty-money-table {
    .el-table__body-wrapper {
        height: 550px;
    }
    .blue {
        background-color: #f1f4ff;
    }
    .yellow {
        background-color: #fffde7;
    }
    .red {
        background-color: #fff5f5;
    }

    .el-table__row {
        cursor: pointer;
    }
}
</style>
